// Types
import type { NotificationSubscriptionProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

const DowngradeReminder = ({ notification }: NotificationSubscriptionProps) => {
    return (
        <Notification
            dataNotification={notification}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="paid-data" />
            <Notification.Content>
                <Notification.Title
                    i18nKey="commons:notifications.downgrade_reminder.title"
                    values={{ plan_name: notification?.data?.plan_name }}
                />
                <Notification.Description i18nKey="commons:notifications.downgrade_reminder.description" />
            </Notification.Content>
        </Notification>
    );
};

export default DowngradeReminder;
